module.exports = __webpack_public_path__ + "img/icn-banque.84d865b0.svg";